const COMPARAI = {
  COLOR: '#2999F1',
  COMPARE_PRICES: 'Compare mais preços',
  PARTNER: 'COMPARAI',
  PARTNER_BADGE: 'PARCEIRO',
  PARTNER_PROMOBIT: 'Parceiro Promobit',
  SEARCH_QUERY_PARAM: 'busca?q=',
  SEE_MORE: 'Veja mais preços',
  UTM_MEDIUM: {
    FINISHED_OFFER: 'encerrada',
    SEARCH: 'busca',
    WHAT_DO_YOU_WANT_TO_PAY_LANDING: 'landing_pay',
  },
};

export default COMPARAI;
